import { render, staticRenderFns } from "./ServiceNew.vue?vue&type=template&id=04105c84&scoped=true"
import script from "./ServiceNew.vue?vue&type=script&lang=js"
export * from "./ServiceNew.vue?vue&type=script&lang=js"
import style0 from "./ServiceNew.vue?vue&type=style&index=0&id=04105c84&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04105c84",
  null
  
)

export default component.exports